import type { JSX } from "react"
import { Blend, Lollipop } from "lucide-react"
import type { Result } from "@/utils/types"
import { decimalToPercent, languages } from "@/lib/utils"
import { ScrollArea, ScrollBar } from "@/components/ui/scroll-area"
import { calculateWPM } from "@/lib/utils"
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card"
import { StatCard } from "./StatCard"

type HighscoreScrollableProps = {
  highscores: Result[]
}

export const HighscoreScrollable: React.FC<HighscoreScrollableProps> = ({ highscores }): JSX.Element | null => {
  return (
    <ScrollArea className="w-auto bg-gray-800 whitespace-nowrap rounded-lg shadow-md">
      <div className="flex w-max space-x-4 p-4">
        {highscores
          .sort((a, b) => b.char_count / b.time_mode - a.char_count / a.time_mode)
          .map((highscore, index) => (
            <Card className="border-0 bg-gray-100" key={index}>
              <CardHeader>
                <CardTitle>
                  <div className="flex flex-row justify-between font-normal">
                    <StatCard
                      description="wpm"
                      value={calculateWPM(
                        highscore.time_mode,
                        highscore.char_count,
                        highscore.language,
                        highscore.strict_mode,
                      ).toFixed(0)}
                    />
                    <div className="flex flex-col justify-center items-center">
                      {/* <div>{languages.find(language => language.code === highscore.language)?.emoji}</div> */}
                      <div>{languages[highscore.language].emoji}</div>
                      <Lollipop className={!highscore.strict_mode ? "w-4" : "w-4 opacity-0"} />
                      <Blend className={highscore.mixed_mode ? "w-4" : "w-4 opacity-0"} />
                    </div>
                  </div>
                </CardTitle>
              </CardHeader>
              <CardContent>
                <div className="flex flex-row gap-3 text-sm text-muted-foreground">
                  <StatCard description="accuracy" value={decimalToPercent(highscore.accuracy)} small={true} />
                  <StatCard description="words" value={highscore.char_count} small={true} />
                  <StatCard description="time" value={highscore.time_mode} small={true} />
                </div>
              </CardContent>
            </Card>
          ))}
      </div>
      <ScrollBar orientation="horizontal" />
    </ScrollArea>
  )
}
